import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import ScrollAnimation from 'react-animate-on-scroll';

class Mission extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="intro-area">
			  <div className="container"><br/><br/>
			    <div className="intro-area-inner-2">
			      <div className="row" >
			        <div className="col-md-6" style={{padding:'0px 30px 30px 50px'}}>
			            <h2 className="title">Mission</h2>
						<ScrollAnimation animateIn="fadeInUp">
							<ul>
                                <li>To educate the poor and needy students and to shape them as disciplined citizen of our Great Country</li>
                                <li>To train and impart necessary soft skills and communication skills with a positive attitude</li>
                                <li>To train our students to become entrepreneurs and readily employable</li>
                                <li>To encourage inter disciplinary knowledge and understanding amongst the students leading to achievements</li>
                                <li>To shape our students not to be the seeker but creator of profession</li>
                            </ul>
						</ScrollAnimation>
					</div>
                    <div className="col-md-6">
                        <center>
                            <img src={publicUrl+"assets/img/website/Best-Education.png"} alt="img" />
                        </center>
                    </div>
			      </div>
			    </div>
			  </div><br/>
			</div>
        }
}

export default Mission